import type { TFunction } from 'i18next';

function isObjectNotEmpty(obj: any) {
  return typeof obj === 'object' && obj !== null && obj !== undefined && obj instanceof Blob;
}

const NON_IMAGE_EXTENSIONS = ['.pdf', '.tif', '.tiff'] as const;

function isNonImageFile(name?: string | null) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return NON_IMAGE_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.mov', '.avi'] as const;

function isVideoFile(name?: string | null) {
  if (!name) return false;
  const lower = name.toLowerCase();
  return VIDEO_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

function formatFileSize(bytes?: number | null): string {
  if (bytes == null || bytes < 0) return '';

  if (bytes < 1024) return `${bytes} B`;

  const units = ['KB', 'MB', 'GB'];
  let size = bytes / 1024;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size % 1 === 0 ? size.toFixed(0) : size.toFixed(1)} ${units[unitIndex]}`;
}

function filesTooLargeMessage(t: TFunction, fileNames: string[], maxBytes: number): string {
  return t('errors.files_too_large', {
    count: fileNames.length,
    files: fileNames.join(', '),
    size: formatFileSize(maxBytes),
  });
}

export { isObjectNotEmpty, isNonImageFile, isVideoFile, formatFileSize, filesTooLargeMessage };
